/**
 * What the WhatsApp switch on a notification category says, shared by web and
 * native so both settings screens read the same.
 */

/** The note under a category's WhatsApp switch, given whether WhatsApp reaches the user. */
export function notificationWhatsappHint(reachable: boolean): string {
  return reachable
    ? "From Okthx's WhatsApp number. Replies come straight back to Okthx."
    : "Connect WhatsApp to get these there.";
}
